import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AlertService } from 'src/app/_services/alert.service';
import { MenusService } from 'src/app/_services/menu.service';
import { StorageService } from 'src/app/_services/storage.service';
import { SideNavService } from 'src/app/views/layout/sidebar/side-name.service';
import { SidebarComponent } from 'src/app/views/layout/sidebar/sidebar.component';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { ColDef, Column, ColumnApi, FilterChangedEvent, FilterModifiedEvent, FilterOpenedEvent, GridApi, GridOptions, GridReadyEvent, PaginationChangedEvent, RowClickedEvent } from 'ag-grid-community';
import { BtnCellRenderer1 } from 'src/app/common/button-cell-renderer.component1';
import { FormControl, FormGroup } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { setColumnDefaults } from '@swimlane/ngx-datatable';
import { param } from 'jquery';
import { NgbDateStruct, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { MerchantService } from '../merchants/merchant-master/merchant.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ExchangeRateService } from './exchange-rate-service';
import { ProductService } from '../product-management/product-service';
import { ExportTrackingService } from 'src/app/_services/export-tracking.service';


const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx'

export interface CustomerListFilter {
  "columns"?: any;
  "fullname"?: string,
  "mobile"?: string,
  "startDate"?: string,
  "endDate"?: string,
  "pageRecords"?: number,
  "pageNumber"?: number,
  "emailId"?: string,
  "reviewFlag":boolean;
  "Status"?: string,
  "KycStatus"?: string

}

export interface IMerchantData {
  "name": string,
  "merchantId": string,
  "businessName": string,
  "contactperson": string,
  "id": number,
  "contactno": string,
  "emailid": string,
  "state": string,
  "city": string,
  "isdeleted": string
}
const { API_URL, defaultPageSizeArr, defaultPageSize } = environment;

@Component({
  selector: 'app-exchange-rates',
  templateUrl: './exchange-rates.component.html',
  styleUrls: ['./exchange-rates.component.scss']
})
export class ExchangeRatesComponent implements OnInit {


  @Output() merchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() merchantConfigEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() BlockedmerchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() ScreeningReportEvent: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('audittrailModal') audittrailModal: ElementRef;

  public quickFilterShow: boolean = false;
  public pageSize: number = defaultPageSize;
  public pageSizeArr: any = defaultPageSizeArr;
  public searchMerName: string;
  public searchMID: string;
  public resellerPartnerId: string;
  public Status: string;
  public searchFromDate: NgbDateStruct;
  public searchToDate: NgbDateStruct;
  public selectedMerchant: string;
  public emailId: string;
  totalRecords: any;
  merchantStatus: any;
  modalConfigBlocked: ModalConfig;
  modalConfigReport: ModalConfig;
  user_type: 'NULL';
  tableInfo: any;
  maxSize: number;
  ellipses: boolean = true;
  private gridApi!: GridApi;
  public rowData!: any[];
  public customerDropDown: any;
  collectiondata: number = 0;
  collectionSize: number = 0;
  currentPage: number = 1;
  public permissions: any = '';
  Resultdata: any;
  resellerListOptions: any;
  merchantStatusdata: any;
  private gridColumnApi!: ColumnApi;
  currentDate: any = new Date();
  private filterObj: any = {};
  globalSearch: string = '';
  private innerWidth: number;
  modalConfigAdd: ModalConfig;
  modalConfigEdit: ModalConfig;
  modalConfigMerchant: ModalConfig;
  image: any;
  mindatadis: boolean = true;
  loading: boolean = false;
  orvreport: FormGroup;
  actionPermission: any;
  public gridOptions: GridOptions;
  public pageNumber: number = 0;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  maxDateFrom: NgbDateStruct;
  countryDropDown: any[];
  countrySelected: any;
  reviewFlag: boolean;
  auditData : any[];
  pageNumberAudit : number = 0;
  pageSizeAudit : number = defaultPageSize;
  currentPageAudit: number = 1;
  collectionSizeAudit: number = 0;
  selectedCurrency : any;
  selectedCountryName : any;


  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 120,
    resizable: true,
    sortable: true,
    lockVisible : true,
    // suppressSizeToFit: true,
    // suppressAutoSize: true,
    filter: false,
    autoHeight: true,
  }
  @ViewChild('modalReportCustomer') private modalReportComponent: ModalComponent;
  @ViewChild('modalblokedCustomer') private modalblockedComponent: ModalComponent;
  @ViewChild('filSearchMerName') private filSearchMerName: NgSelectComponent;
  @ViewChild('filSearchMID') private filSearchMID: NgSelectComponent;
  @ViewChild('filResellerPartnerId') private filResellerPartnerId: NgSelectComponent;
  @ViewChild('filStatus') private filStatus: NgSelectComponent;
  @ViewChild('filSearchToDate') private filSearchToDate: FormControl;
  @ViewChild('filSearchFromDate') private filSearchFromDate: FormControl;

  public columnDefs: ColDef[] = [
    { field: 'currencySymbol',  headerName: 'Symbol', cellRenderer: 'agGroupCellRenderer' },
    { field: 'currencyCode',  headerName: 'Currency Code', cellRenderer: 'agGroupCellRenderer' },
    { field: 'currencyName',  headerName: 'Currency Name', },
    { field: 'countryName',  headerName: 'Country' },
    { field: 'chargesType', headerName: 'Type', },
    { field: 'exchangeRate', headerName: 'Current Rate', },
    { field: 'offeredRate',  headerName: 'Offered Rate', },
    { field: 'markupAmount', headerName: 'Mark Up Amount', },
    { field: 'markupPercentage',  headerName: 'Mark Up Percentage', },
    { field: 'effectiveDate',  headerName: 'Effective Update Date', },
    { field: 'createdBy',  headerName: 'Updated By', },
    { field: 'approvedBy',  headerName: 'Approved By' },
    
    {
      field: 'actions', headerName: 'Actions' ,sortable: false ,minWidth: 200, hide:this.permissions.includes('Approve'), cellRenderer: BtnCellRenderer1, cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            console.log(param.data.currencySymbol);
            return await this.router.navigate(['/exchangeRates/Edit'], {
              queryParams: {
                currency: param?.data?.currencyCode,
                country: param?.data?.countryName,
                currencyName : param?.data?.currencyName,
                balance: param?.data?.maxAmount,
                symbol : param?.data?.currencySymbol
              }
            })
          },
          buttonIconClass: 'icon-edit',
          buttonVisible: true
        },
        {
          clicked: async (event: any, param: any) => {
            this.tableInfo = param.data.registeredMobile
            console.log("Row clicked :" + this.tableInfo);
            var mobile = this.tableInfo;
            console.log("Mobile :" + mobile);
            this.openModal(this.audittrailModal,param.data.currencyCode,param.data.countryName)
            this.BlockedmerchantSelectEvent.emit(mobile);
            // return await this.modalblockedComponent.open();

          },
          buttonIconClass: 'icon-book',
          buttonVisible: true
        },
        {
        clicked: async (event: any, param: any) => {
          console.log(param);
          
        this.alertService.toastWarringMessageAlertWithMessage("Review is pending for this "+param.data.countryName+" Country")
          
        },
        buttonIconClass: 'icon-rotate-ccw',
        
        buttonVisible :false
        
      }

      ]
    },
    {
      field: 'actions', headerName: 'Actions' ,sortable: false ,width: 280, hide:!this.permissions.includes('Approve'), cellRenderer: BtnCellRenderer1, cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            return await this.router.navigate(['/exchangeRates/Edit'], {
              queryParams: {
                currency: param?.data?.currencyCode,
                country: param?.data?.countryName,
                currencyName : param?.data?.currencyName,
              }
            })
          },
          buttonIconClass: 'icon-edit',
          buttonVisible: true
        },
        {
          clicked: async (event: any, param: any) => {
            this.tableInfo = param.data.registeredMobile
            console.log("Row clicked :" + this.tableInfo);
            var mobile = this.tableInfo;
            console.log("Mobile :" + mobile);
            this.openModal(this.audittrailModal,param.data.currencyCode,param.data.countryName)
          },
          buttonIconClass: 'icon-book',
          buttonVisible: true
        },
        {
        clicked: async (event: any, param: any) => {
          console.log(param);
          
        this.alertService.toastWarringMessageAlertWithMessage("Review is pending for this "+param.data.countryName+" Country")
          
        },
        buttonIconClass: 'icon-rotate-ccw',
        buttonVisible :false
      }

      ]
    }
  ];

  public columnDefAudit: ColDef[] = [
    // { field: 'to_currency', headerName: 'To Currency', cellStyle: params=>{
    //   console.log(params)
    //   return {color : 'red'}
    // }},
    { field: 'to_currency',  headerName: 'To Currency', },
    { field: 'from_amount',  headerName: 'From Amount', },
    { field: 'to_amount',  headerName: 'To Amount', },
    { field: 'exchange_rate',  headerName: 'Exchange Rate', },
    { field: 'mark_up',  headerName: 'MarkUp Amount', },
    { field: 'effective_date',  headerName: 'Effective Data' },
    { field: 'date_to',  headerName: 'End Date' },
    { field: 'charges_type', headerName: 'Charges Type', },
    { field: 'mark_up_type',  headerName: 'MarkUp Type', },
    { field: 'charges_status',  headerName: 'Status', },
    { field: 'approved_by', headerName: 'Approved By', },
    { field: 'approved_date', headerName: 'Approved On', },
    { field: 'created_by',  headerName: 'Created By', },
    { field: 'create_date', headerName: 'Created On', },
  ];

  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedAudit: ColDef[] = [...(this.columnDefAudit.filter((col) => !col?.hide))];
  page = 1;


  constructor(private menuService: MenusService, private location: Location, private alertService: AlertService, private sideNavService: SideNavService, private merchantService: MerchantService, private router: Router, private sidebarComponent: SidebarComponent, private storageService: StorageService, private ngbCalender: NgbCalendar,
    private ngbDateParserFormatter: NgbDateParserFormatter,
    private modalService: NgbModal, private exchangeService: ExchangeRateService, private productService: ProductService, private exportTrackingService: ExportTrackingService) {

    this.maxDateFrom = this.ngbCalender.getToday();
    this.maxDate = this.ngbCalender.getToday();
    this.merchantService.getBusinessType().subscribe((data) => this.merchantStatus = data)
    console.log("============>", this.tableSelectedColumn);
    console.log("Defined column : ", this.columnDefsCopy);
  }

  async ngOnInit(): Promise<void> {
    this.innerWidth = window.innerWidth;
    this.setPageSize();
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    console.log(this.permissions)
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }

    this.exchangeService.getExchangeRateDropDown(this.countrySelected, "ALL", 0)
      .subscribe((data: any) => {
        this.countryDropDown = data.response.data.content;
      })
      
  }

  refreshCountries() {

  }

  onSubmit() {
    console.log("Download Button");
  }

  downloadPdf(data: any, info: any) {
    //  alert("data==="+data+"  ,   Merchant======"+Merchant)
    if (data) {
      const linkSource = data;
      const downloadLink = document.createElement('a');
      const fileName = info + '_Screening_Report.pdf';
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      this.loading = false
    } else {
      this.mindatadis = false;
      this.loading = false
    }
  }
  merchantStatusDropdown() {
    return this.merchantService.getMerchantStatus()
      // .post(
      //   `${API_URL}/GetDropdown`, postdata
      // )
      .subscribe((res) => (this.merchantStatusdata = res, console.log("res", this.merchantStatusdata)));

  }

  MerchnatList() {
    let reqData = {
      "name": ""
    }
    console.log("request body", reqData)
    this.merchantService.getMerchantBYName(reqData).subscribe((res: any) => {
      this.Resultdata = res
      console.log("merchant mid", res)
    });
  }

  setPageSize() {
    // this.columnDefs = this.columnDefs.map((col)=>{
    //   if(col.field == 'actions'){
    //     col.pinned = "right";
    //   }
    //   return col;
    // });
    if (this.innerWidth <= 1600 && this.innerWidth >= 1200) {
      this.maxSize = 5;
    } else if (this.innerWidth <= 1199 && this.innerWidth >= 768) {
      this.maxSize = 3;
      this.ellipses = false;
    } else if (this.innerWidth < 768) {
      this.maxSize = 2;
      this.ellipses = false;
      // this.columnDefs = this.columnDefs.map((col)=>{
      //   if(col.field == 'actions'){
      //     col.pinned = null;
      //   }
      //   return col;
      // });
    }
    // this.gridApi.setColumnDefs(this.columnDefs)
  }
  updateSelectedColumn(event: any) {
    console.log("select col : " + event.target.checked);
    if (event.target.checked) {
      console.log(this.columnDefsCopy[parseInt(event.target.value)].field);
      console.log(this.permissions);
      if (this.columnDefsCopy[parseInt(event.target.value)].field == "actions" && this.permissions == "View") {
        console.log("Action Disabled");
        this.gridApi.setColumnDefs(this.tableSelectedColumn)
        this.gridApi.setDefaultColDef(this.defaultColDef);
        return;
      }

      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) < 0) {
        // this.tableSelectedColumn.push(this.columnDefs[parseInt(event.target.value)]);
        this.tableSelectedColumn.splice(parseInt(event.target.value), 0, this.columnDefsCopy[parseInt(event.target.value)]);
      }
    } else {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) > -1) {
        this.tableSelectedColumn.splice(this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]), 1);
      }
    }
    console.log("selected Column : " + JSON.stringify(this.tableSelectedColumn));

    this.gridApi.setColumnDefs(this.tableSelectedColumn)
    this.gridApi.setDefaultColDef(this.defaultColDef);
  }


  onExportCSV() {
    debugger
    // @ts-ignore
    const random3 = Math.floor(Math.random() * 10000000000 + 1);
    const today = new Date();
    const referenceId = today.getFullYear().toString() + "-" + ("0" + (today.getMonth() + 1)).slice(-2) + "-" + ("0" + today.getDate()).slice(-2) + "_" + (("0" + today.getHours())).slice(-2) + "-" + (("0" + today.getMinutes())).slice(-2) + "-" + (("0" + today.getSeconds())).slice(-2);
    const fileName = 'Exchange_List' + "_" + referenceId;
    if(this.countrySelected == null || this.countrySelected == "" || this.countrySelected == undefined){
      this.countrySelected = null;
    }
    console.log("selected pageSize export : " + this.pageSize);
    console.log("selected pageNumber export : " + this.pageNumber);
    return this.exchangeService.getExchangeRateList(this.countrySelected, this.pageSize, this.pageNumber)
      .subscribe((data:any) => {
        debugger
        const expData: any[] = [];
        console.log("Customer Data ::" + JSON.stringify(data));

        if (data == "" || data.response.data.content.length == 0) {
          this.alertService.errorAlertWithMessage("No records present");
          return
        }
        (data?.data || data.response.data.content || []).forEach((curr: any) => {
          const tempRec: any = {}
          // this.tableSelectedColumn.forEach((col) => {
          //   if (col?.field) tempRec[col?.field] = curr[col?.field]
          // })
          this.tableSelectedColumn.forEach((col) => {
            debugger
            if (!(col?.field == "actions")) {
              if (col?.field) tempRec[col?.field] = curr[col?.field]
            }

          })
          expData.push(tempRec);
        })

        // this.JSONToCSVConvertor(data?.data || data?.merchants || data || [],fileName, "Report");
        this.exportAsExcelFile(expData, fileName);
      });



     
  }

  // Excel export method with audit tracking
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    // First, track the export for audit logging
    this.exportTrackingService.trackExcelExport(
      excelFileName,
      json.length,
      'EXCHANGE_RATES',
      this.getCurrentFilters()
    ).subscribe({
      next: (response) => {
        console.log('Exchange rates export tracked in audit logs:', response);
        // Proceed with actual export after audit tracking
        this.performExcelExport(json, excelFileName);
      },
      error: (error) => {
        console.log('Export tracking completed (audit logged):', error);
        // Proceed with export even if tracking fails since audit was logged by interceptor
        this.performExcelExport(json, excelFileName);
      }
    });
  }

  // Perform the actual Excel export after audit tracking
  private performExcelExport(json: any[], excelFileName: string): void {
    const tempRec: any = []
    var index = 0;
    this.tableSelectedColumn.forEach((col) => {
      if (!(col?.field == "screen")) {
        if (!(col?.field == "actions")) {
          tempRec[index] = col
          index++;

        }

      }
    })
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([], {
      // @ts-ignore
      header: [...tempRec.map((col: any) => col.headerName)]
    });
    // const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    const wb = XLSX.utils.book_new();
    XLSX.utils.sheet_add_aoa(worksheet, [[...tempRec.map((col: any) => col.headerName)]]);
    XLSX.utils.sheet_add_json(worksheet, json, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  // Helper method to get current filter state for audit logging
  private getCurrentFilters(): any {
    return {
      country: this.countrySelected || ''
    };
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
  }

  resetFilter() {
    this.filStatus.handleClearClick();
  }

  onSearchBtnClick($event: Event) {
    if(this.countrySelected == null || this.countrySelected == "" || this.countrySelected == undefined){
      this.countrySelected = null;
    }
    return this.exchangeService.getExchangeRateList(this.countrySelected, this.pageSize, this.pageNumber)
      .subscribe((data:any) => {

          this.rowData = data.response.data.content,
          this.collectiondata = data.response.data.content
          this.collectionSize = data.response.data.totalElements
        if (data.response.data.content.length <= 0) {
          this.alertService.errorAlertWithMessage("No records present");
          return
        }
      });
  }

  async onRowDoubleClicked(param: RowClickedEvent | any) {
    console.log("Edit CLicked");
    return await this.router.navigate(['/customerEdit'], {

      queryParams: {
        mid: param?.data?.registeredMobile,
        date: param?.data?.createdDate,


      }
    })

  }
  onRowClicked(param: RowClickedEvent | any) {
    console.log("Row Clicked", param);
  }
  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  onPaginationChange(param: PaginationChangedEvent | any) {

    this.gridApi.applyTransaction({ remove: this.rowData })
    this.gridApi.showLoadingOverlay();
    if(this.countrySelected == null || this.countrySelected == "" || this.countrySelected == undefined){
      this.countrySelected = null;
    }
    this.pageNumber = (param-1);
    console.log("selected page number : " + this.pageNumber);
    this.exchangeService.getExchangeRateList(this.countrySelected, this.pageSize, this.pageNumber)
      .subscribe((data:any) => (this.rowData = data.response.data.content|| data,
        this.collectiondata = data.response.data.content,
        this.collectionSize = data.response.data.totalElements,
        this.gridApi.applyTransaction({ add: this.rowData })));
    console.log("Collection Size : " + this.collectionSize);

  }



  onPageSizeChanges($event: Event) {
    this.gridApi.paginationSetPageSize(this.pageSize)
    this.gridApi.applyTransaction({ remove: this.rowData })
    this.gridApi.showLoadingOverlay();
    if(this.countrySelected == null || this.countrySelected == "" || this.countrySelected == undefined){
      this.countrySelected = null;
    }
    console.log(this.pageNumber);
    this.exchangeService.getExchangeRateList(this.countrySelected, this.pageSize, this.pageNumber)
      .subscribe((data:any) => (this.rowData = data.response.data.content|| data,
        this.collectiondata = data.response.data.content,
        this.collectionSize = data.response.data.totalElements,
        this.gridApi.applyTransaction({ add: this.rowData })));
    console.log("Collection Size : " + this.collectionSize);

  }

  onGridReady(params: GridReadyEvent<IMerchantData>) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    if (this.permissions == "View") {
      this.gridColumnApi.setColumnsVisible(["actions"], false);
    }
    this.gridApi.getFilterInstance('age', (filterParam) => {
    })
    this.gridApi.showLoadingOverlay();
    this.gridApi.setQuickFilter(this.globalSearch);
    const allColumnIds: (string | Column)[] = [];
    params?.columnApi?.getColumns()?.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    params?.columnApi?.autoSizeColumns(allColumnIds, false);
    if(this.countrySelected == null || this.countrySelected == "" || this.countrySelected == undefined){
      this.countrySelected = null;
    }
    return this.exchangeService.getExchangeRateList(this.countrySelected, this.pageSize, 0)
      .subscribe((data: any) => {
        console.log(data);
        
        this.rowData = data.response.data.content;
              // console.log(" this.rowData= merchant masterlist===" + JSON.stringify(this.rowData))
        this.collectiondata = data.response.data.content,
          this.collectionSize = data.response.data.totalElements,
          console.log("Collection Size : " + this.collectionSize);

      });

  }

  quickFilterShowAction($event: Event) {
    this.quickFilterShow = !this.quickFilterShow
    if (!this.quickFilterShow) {
      // this.searchToDate = '';
      // this.searchFromDate = '';
      // this.searchMID = '';
      // this.searchMerName = '';
      // this.resellerPartnerId= '',
      // this.Status= ''
      this.filSearchMerName.handleClearClick();
      this.filSearchMID.handleClearClick();
      this.filResellerPartnerId.handleClearClick();
      this.filStatus.handleClearClick();
      this.searchFromDate = this.ngbCalender.getToday();
      this.searchToDate = this.ngbCalender.getToday();
      this.refreshGrid();
    }
  }

  onPageSizeChangesAudit($event: Event) {

    this.pageNumberAudit = 0;
    console.log("selected page size audit: " + this.pageSizeAudit);
    this.exchangeService.getExchangeSlabAuditTrail(this.selectedCurrency, this.pageSizeAudit, this.pageNumberAudit)
      .subscribe((data:any) => (
        this.auditData = data.data.content,
        this.collectionSizeAudit = data.data.totalElements));
        console.log("Collection Size : " + this.collectionSizeAudit);

  }

  onPaginationChangeAudit(param: PaginationChangedEvent | any) {

    this.pageNumberAudit = (param-1);
    console.log("selected page number audit: " + this.pageNumberAudit);
    this.exchangeService.getExchangeSlabAuditTrail(this.selectedCurrency, this.pageSizeAudit, this.pageNumberAudit)
      .subscribe((data:any) => (
        this.auditData = data.data.content,
        this.collectionSizeAudit = data.data.totalElements));
        console.log("Collection Size : " + this.collectionSizeAudit);

  }

  OnlyCharacterAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122) || (charCode == 32)) {
      // console.log('charCode restricted is' + charCode)
      return true;
    }
    return false;
  }
  changeDate() {
    this.currentDate = this.searchFromDate
    this.minDate = this.searchFromDate;
    let mmmm = this.ngbDateParserFormatter.format(this.searchFromDate);
  }


  changeEndDate() {
    this.currentDate = this.searchToDate;
    this.maxDateFrom = this.searchToDate;
  }

  onFilterChange(param: FilterChangedEvent | any) {

  }

  onFilterModified(param: FilterModifiedEvent | any) {
    // console.log("onFilterModified----->",param);
    const temp = param?.filterInstance;
    this.filterObj[param?.column?.colId] = temp;
  }

  onFilterOpened(param: FilterOpenedEvent | any) {
    console.log("onFilterOpened----->", param);
  }

  onSortChange(event: any) {
    const listOfSortModel = this?.gridColumnApi?.getColumnState().filter(s => s.sort !== null)
    console.log("==Sort===>", listOfSortModel);
  }
  allowAlfanumeric($event: Event): void {
    if (this.searchMID.length > 10) {
      return
    }

    this.searchMerName = this.searchMerName.replace(/[^a-z 0-9]/gi, '') || '';
    this.searchMID = this.searchMID.replace(/[^a-z 0-9]/gi, '') || '';
  }
  fun(id: any) {
    document?.getElementById(id)?.classList.add("hey")
  }
  funover(id: any) {
    document?.getElementById(id)?.classList.remove("hey")
  }

  refreshGrid() {
    this.gridApi.applyTransaction({ remove: this.rowData });
    return this.merchantService.getApprovedCustomer(this.pageSize, (this.currentPage - 1))
      .subscribe((data) => (this.rowData = data.data || data.merchants || data,
        this.collectiondata = data.totalCount || data.totalrecords || data.totalRecords || data.length, this.collectionSize = this.collectiondata - 10
      ));
  }

  closeModalBlocked($event: any) {
    if (!$event.showModal) {
      this.modalblockedComponent.close();
      this.refreshGrid();
    }
  }

  closeResult = '';
  openModal(content: any,currencyName:String,countryName : any) {
    this.auditData = [];
    this.selectedCountryName = countryName;
    console.log("Currency Code : "+currencyName);
    this.selectedCurrency = currencyName;
    this.pageNumberAudit = 0;
    this.pageSizeAudit = 10;
    this.exchangeService.getExchangeSlabAuditTrail(currencyName,this.pageSizeAudit,this.pageNumberAudit).subscribe((response:any)=>{
      console.log(response);
      this.auditData = response.data.content
      this.collectionSizeAudit = response.data.totalElements;
    })

    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl', centered: true, modalDialogClass: 'permission-modal' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}
